var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (config, continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, leftItems, playinline, prompt, rightItems, submitUp, undefined) {
jade_mixins["video-stream"] = jade_interp = function(videoUrl, playsinline, controls, klass, poster){
var block = (this && this.block), attributes = (this && this.attributes) || {};
playinline = playinline || true
controls = controls || true
klass = klass || 'video vjs-fluid'
var cloudinaryVideoFolderUrl = config.CLOUDINARY_CDN_URL+config.CLOUDINARY_VIDEO_FOLDER
var streamUrl = ''
if ( videoUrl && videoUrl.indexOf(cloudinaryVideoFolderUrl) > -1)
{
streamUrl = videoUrl.replace(cloudinaryVideoFolderUrl, cloudinaryVideoFolderUrl+'sp_full_hd/')
streamUrl = streamUrl.replace('.mp4', '.m3u8')
}
buf.push("<video" + (jade.attr("webkit-playsinline", playsinline, true, false)) + (jade.attr("controls", controls, true, false)) + " preload=\"auto\"" + (jade.attr("dir", config.direction, true, false)) + (jade.attr("poster", poster, true, false)) + (jade.cls(['video-js',klass], [null,true])) + "><source" + (jade.attr("src", videoUrl, true, false)) + "/>");
if ( streamUrl)
{
buf.push("<source" + (jade.attr("src", streamUrl, true, false)) + "/>");
}
buf.push("</video>");
};
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
jade_mixins["multi-content"] = jade_interp = function(prop, obj){
var block = (this && this.block), attributes = (this && this.attributes) || {};
obj = obj || locals;
switch (obj[prop + "Type"]){
case "image":
buf.push("<div" + (jade.attr("data-content", obj.image, true, false)) + " class=\"multi-content-wrapper multi-content-wrapper-image block-md block-lt\"><div class=\"block-sm multi-content-media\">");
jade_mixins["image"](obj[prop], 'multi-content multi-content-image');
buf.push("</div></div>");
  break;
case "video":
buf.push("<div class=\"multi-content-wrapper multi-content-wrapper-video block-md block-lt\"><div class=\"block-sm multi-content-media\">");
jade_mixins["video-stream"](obj[prop], true, true,"multi-content multi-content-video block-dk");
buf.push("</div></div>");
  break;
case "audio":
buf.push("<div class=\"multi-content-wrapper multi-content-wrapper-audio block-md block-lt\"><div class=\"block-sm multi-content-media\"><audio" + (jade.attr("src", obj[prop], true, false)) + " playsinline=\"playsinline\" preload=\"auto\" controls=\"controls\"" + (jade.attr("dir", config.direction, true, false)) + " class=\"multi-content multi-content-audio block-dk\"></audio></div></div>");
  break;
case "iframe":
buf.push("<div class=\"multi-content-wrapper multi-content-wrapper-iframe block-md block-lt\"><div class=\"block-sm multi-content-iframe\">");
var iframe = obj[prop].match(/<iframe[^<]*<\/iframe>/)
if ( iframe)
{
buf.push(null == (jade_interp = iframe[0].replace(/ (width|height)=["'\d\w]+/g, "")) ? "" : jade_interp);
}
buf.push("</div></div>");
  break;
default:
buf.push("<span class=\"multi-content multi-content-text\">" + (null == (jade_interp = obj[prop]) ? "" : jade_interp) + "</span>");
  break;
}
};
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"full-screen connect-canvas-container\"><canvas class=\"connect-canvas\"></canvas></div><div class=\"content-fill\"><div class=\"content-fit connect-boxes content-md-fill content-sm-ver block-v-lg\"><div class=\"content-md-ver text-center\"><h1 class=\"fade-in\">");
jade_mixins["multi-content"]("title");
buf.push("</h1>");
// iterate leftItems
;(function(){
  var $$obj = leftItems;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var left = $$obj[i];

buf.push("<div class=\"row\"><div" + (jade.cls(['block-v-sm','col-sm-6','col-lg-5','col-lg-offset-1','slide-right',"delay-" + (i + 4) + ""], [null,null,null,null,null,true])) + "><div" + (jade.attr("data-index", left.index, true, false)) + " data-type=\"left\"" + (jade.attr("data-question-id", left.id, true, false)) + " class=\"connect-box block-md block-dk\">");
jade_mixins["multi-content"]("content", left);
buf.push("</div></div><div" + (jade.cls(['block-v-sm','col-sm-6','col-lg-5','slide-left',"delay-" + (i + 4) + ""], [null,null,null,null,true])) + "><div" + (jade.attr("data-index", rightItems[left.index].index, true, false)) + " data-type=\"right\"" + (jade.attr("data-answer-ids", rightItems[left.index].ids, true, false)) + " class=\"connect-box block-md block-dk\">");
jade_mixins["multi-content"]("content", rightItems[left.index]);
buf.push("</div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var left = $$obj[i];

buf.push("<div class=\"row\"><div" + (jade.cls(['block-v-sm','col-sm-6','col-lg-5','col-lg-offset-1','slide-right',"delay-" + (i + 4) + ""], [null,null,null,null,null,true])) + "><div" + (jade.attr("data-index", left.index, true, false)) + " data-type=\"left\"" + (jade.attr("data-question-id", left.id, true, false)) + " class=\"connect-box block-md block-dk\">");
jade_mixins["multi-content"]("content", left);
buf.push("</div></div><div" + (jade.cls(['block-v-sm','col-sm-6','col-lg-5','slide-left',"delay-" + (i + 4) + ""], [null,null,null,null,true])) + "><div" + (jade.attr("data-index", rightItems[left.index].index, true, false)) + " data-type=\"right\"" + (jade.attr("data-answer-ids", rightItems[left.index].ids, true, false)) + " class=\"connect-box block-md block-dk\">");
jade_mixins["multi-content"]("content", rightItems[left.index]);
buf.push("</div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"leftItems" in locals_for_with?locals_for_with.leftItems:typeof leftItems!=="undefined"?leftItems:undefined,"playinline" in locals_for_with?locals_for_with.playinline:typeof playinline!=="undefined"?playinline:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"rightItems" in locals_for_with?locals_for_with.rightItems:typeof rightItems!=="undefined"?rightItems:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}